import ResourceComponent from '../../../common/ResourceComponent';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from '../EmbeddableApi';
import {connect} from 'react-redux';
import {Button, ButtonToolbar, Col, Row} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilter, faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import SortDropdown from './SortDropdown';
import {formatPhoneNumber} from 'react-phone-number-input';

class MobileMenu extends ResourceComponent {

    render() {
        const {
            settings,
            claimedItems,
            setAvailableInventory,
            getItemRange,
            claimEnabled,
            clientInformation,
            loading,
            items,
            toggleFilter,
            openSubmitModal,
            filters,
            changeSort,
            hideFilters,
            ecommerceConnected,
            bundle_card_detail,
        } = this.props;
        const {customerLogoUrl, phoneNumber, website} = clientInformation;

        const mobileMenuStyle = () => settings.sticky_header ? {
            zIndex: 50,
            position: 'fixed',
            left: 0,
            paddingLeft: '10px',
            backgroundColor: settings.main_container_color ?
                settings.main_container_color : window.getComputedStyle(document.body).getPropertyValue('background-color'),
        } : {
            zIndex: 50,
            backgroundColor: settings.main_container_color ?
                settings.main_container_color : window.getComputedStyle(document.body).getPropertyValue('background-color'),
        };

        return <Row className={'header-container mobile-container m-0 ms-sm-1 p-2'} style={mobileMenuStyle()}>
            {settings.show_logo_and_contact && <Col className='d-flex p-0'>
                <Col sm={3} className='p-0'>
                    <div className='logo-content'>
                        <div className='logo ml-1'>
                            {website ? (
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    href={`https://${website}`}>
                                    <img style={{height: '50px'}} src={customerLogoUrl ? customerLogoUrl : ''} />
                                </a>
                            ) : <img style={{height: '50px'}} src={customerLogoUrl ? customerLogoUrl : ''} />}

                        </div>
                    </div>
                </Col>
                {phoneNumber && <Col sm={9} className='pr-md-0 d-flex justify-content-end align-content-center'>
                    <Row className='d-flex align-content-center mr-lg-2'>
                        <span>Contact Us: {formatPhoneNumber(phoneNumber)}</span>
                    </Row>
                </Col>}
            </Col>}
            <Col className='d-flex ms-0 p-0 p-sm-1 justify-content-between align-content-center' md={12}>
                <div>
                    <span className='h6'>Available inventory: </span>
                    <span className='h5'><b>{setAvailableInventory()}</b></span>
                </div>
                <SortDropdown filters={filters} changeSort={changeSort} loading={loading} />
            </Col>
            <Col
                className={`d-flex ${claimedItems.length > 0 && (claimEnabled || (!claimEnabled && ecommerceConnected)) ? 'justify-content-between' : 'justify-content-end'} p-0 p-sm-1`}
                md={12}>
                {claimedItems.length > 0 && (claimEnabled || (!claimEnabled && ecommerceConnected)) &&
                    <div className='d-sm-flex align-items-center'>
                        <div>
                            {claimEnabled
                                ? <span className='h6'>Claimed Items</span>
                                : <span className='h6'><FontAwesomeIcon icon={faShoppingCart} /> Items In Cart</span>}
                            : <span className='h5 mr-3'><b>{claimedItems.length}</b></span>
                        </div>
                        <ButtonToolbar>
                            <Button className='mr-1' size='sm' color='success' onClick={() => openSubmitModal()}>
                                {claimEnabled ? 'Submit' : 'Checkout'}
                            </Button>
                            <Button size='sm' color='danger' onClick={this.props.actions.emptyClaimedItems}>
                                Cancel
                            </Button>
                        </ButtonToolbar>
                    </div>
                }
                <div className='ml-1 d-flex flex-column flex-sm-row align-items-end align-items-sm-center float-right'>
                    <span className={`ml-1 text-primary ${hideFilters ? 'mr-2' : ''}`}>
                        <b>{getItemRange()}</b> of {items.total_entries || 0} results
                    </span>
                    {!hideFilters &&
                        <Button className='ms-sm-3 me-sm-2' size='sm' color='primary' onClick={() => toggleFilter()}>
                            <FontAwesomeIcon icon={faFilter} />
                            Filter
                        </Button>}
                </div>
            </Col>
        </Row>;
    }
}

MobileMenu.contextTypes = {
    router: PropTypes.object,
};

MobileMenu.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MobileMenu);


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/MobileMenu.js